import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  success: '',
  addEmployeeData: null,
  isSuccess: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.ADD_EMPLOYEE_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false,
      };
    case actionConstants.ADD_EMPLOYEE_SUCCESS:
      return {
        ...state,
        addEmployeeData: action.payload,
        isfetching: false,
        success: action.message,
        isSuccess: true,
      };
    case actionConstants.ADD_EMPLOYEE_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false,
      };
    case actionConstants.RESET_TEAM_REDUCER:
      return {
        ...state,
        isSuccess: false,
        error: '',
      };
    default:
      return state;
  }
};
